module.exports = __webpack_public_path__ + "img/Facebook Messenger.d67e838c.png";